<template>
    <div
        class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700 overflow-y-clip">
      <TsCarouselV2
          :navigation="!(isMobile || isTablet)"
          :pagination="false"
          append-class="mb-6 px-4 lg:flex lg:justify-center"
      >
        <template #default>
          <TsCarouselSlide
              v-for="(item, index) in tabs"
              :key="index"
              @click="handleClick(index)"
              append-class="flex-[0_0_auto] px-2.5"
          >
            <span :class="twMerge(
                'cursor-pointer lg:mx-4',
                index === activeTab && 'text-blue-600 border-b-[3px] border-blue-600 inline-block dark:text-blue-500 dark:border-blue-500'
            )">{{ item.label }}</span>
          </TsCarouselSlide>
        </template>
      </TsCarouselV2>
      <slot name='content'>
        <div v-if="activeTabContent">
          <Blocks
              :parent="props.builderBlock?.id"
              :path="`component.options.tabs.${activeTab}.content`"
              :blocks="activeTabContent"
          />
        </div>
      </slot>
    </div>
  </template>
  
  <script setup lang="ts">
  import {ref, computed} from 'vue';
  import {Blocks} from '@builder.io/sdk-vue';
  import {twMerge} from "tailwind-merge"

  const TsCarouselV2 = defineAsyncComponent(
      () => import('~/components/organisms/TsCarouselV2.vue')
  );

  const TsCarouselSlide = defineAsyncComponent(
      () => import('~/components/organisms/TsCarouselSlide.vue')
  );

  const isNavigationVisible = ref(false);
  const {isMobile, isTablet} = useDevice();

  type Props = {
    tabs?: any,
    builderBlock?: object,
    defaultActiveTab?: number,
    collapsible?: boolean,
    tabHeaderLayout?: string,
    activeTabStyle?: object,
  }
  
  const props = withDefaults(defineProps<Props>(), {});
  
  const activeTab = ref(props.defaultActiveTab ? props.defaultActiveTab - 1 : 0);
  // Compute the active tab's content directly
  const activeTabContent = computed(() => {
    // Ensure tabs exist and have content
    return props.tabs && props.tabs.length > activeTab.value
        ? props.tabs[activeTab.value].content
        : undefined;
  });
  
  function handleClick(index) {
    if (index === activeTab.value && props.collapsible) {
      activeTab.value = -1; // Collapse tab
    } else {
      activeTab.value = index; // Set active tab
    }
  }
  </script>
